<template>
  <v-flex
    id="schoolSupplies"
    class="question"
  >
    <p class="mb-0 text-uppercase">
      {{ $t('sheet.sheet_two.hint') }}
    </p>
    <h2 class="header mb-0">
      {{ getSchoolSuppliesQuestions.label }}
    </h2>
    <ul class="questions-list">
      <li
        v-if="getSchoolSuppliesQuestions.hasOwnProperty('need_school_supplies')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getSchoolSuppliesQuestions.need_school_supplies.required }"
        >
          {{ getSchoolSuppliesQuestions.need_school_supplies.label }}
        </p>
        <ConfirmButtons
          v-model="needSchoolSupplies"
          v-validate="{ required: getSchoolSuppliesQuestions.need_school_supplies.required }"
          string
          :error-messages="errors.collect('needSchoolSupplies')"
          :data-vv-as="' '"
          :data-vv-name="'needSchoolSupplies'"
          :disabled="readOnly"
        />
      </li>
      <li
        v-if="
          needSchoolSupplies === 'yes' &&
            getSchoolSuppliesQuestions.hasOwnProperty('selected_supplies')
        "
        class="mt-4"
      >
        <p
          class="header custom lA"
          :class="{ required: getSchoolSuppliesQuestions.selected_supplies.required }"
        >
          {{ getSchoolSuppliesQuestions.selected_supplies.label }}
        </p>
        <v-layout wrap>
          <v-flex
            v-for="(item, index) in suppliesList"
            :key="index"
            lg3
            md4
            sm6
            xs6
          >
            <v-checkbox
              v-model="selectedSupplies"
              v-validate="{ required: getSchoolSuppliesQuestions.selected_supplies.required }"
              multiple
              :label="item.description"
              :value="item.id"
              :error="errors.has('selectedSupplies')"
              :error-messages="
                index + 1 === suppliesList.length ? errors.collect('selectedSupplies') : null
              "
              :data-vv-as="' '"
              :data-vv-name="'selectedSupplies'"
              :disabled="readOnly"
            />
          </v-flex>
        </v-layout>
        <div
          v-if="
            showAnotherField && getSchoolSuppliesQuestions.hasOwnProperty('another_school_supplies')
          "
          class="mt-4"
        >
          <p
            class="fw-600 mb-0"
            :class="{ required: getSchoolSuppliesQuestions.another_school_supplies.required }"
          >
            {{ getSchoolSuppliesQuestions.another_school_supplies.label }}
          </p>
          <v-textarea
            v-model="anotherSchoolSupplies"
            v-validate="{
              ...requiredRegularField(getSchoolSuppliesQuestions.another_school_supplies.required)
            }"
            :placeholder="$t('placeholders.add_text')"
            :error-messages="errors.collect('schoolSupplies')"
            :data-vv-as="' '"
            data-vv-name="schoolSupplies"
            :required="getSchoolSuppliesQuestions.another_school_supplies.required"
            :disabled="readOnly"
            :rows="1"
            auto-grow
          />
        </div>
      </li>
    </ul>
    <v-divider class="my-4" />
  </v-flex>
</template>

<script>
import ConfirmButtons from '@/components/widgets/sheet/ConfirmButtons';

import validationRules from '@/constants/validationRules';
import { createHelpers } from 'vuex-map-fields';
import { mapGetters } from 'vuex';

import sheetResourcesGetter from '@/mixins/sheet/sheetResourcesGetter';
import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';

const { mapFields } = createHelpers({
    getterType: 'sheet/getSchoolSuppliesFields',
    mutationType: 'sheet/updateSchoolSuppliesFields'
});

export default {
    name: 'SchoolSupplies',
    components: { ConfirmButtons },
    mixins: [sheetResourcesGetter, sheetValidationRules],
    inject: ['$validator'],
    props: {
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            validationRules
        };
    },
    computed: {
        ...mapFields(['needSchoolSupplies', 'selectedSupplies', 'anotherSchoolSupplies']),
        suppliesList () {
            return this.getSheetTwoResources(this.getSchoolSuppliesQuestions.selected_supplies);
        },
        showAnotherField () {
            if (this.showAnotherFieldId) {
                return this.selectedSupplies.includes(this.showAnotherFieldId.id);
            }
            return false;
        },
        showAnotherFieldId () {
            return this.suppliesList.find((el) => el.description === 'Inne');
        },
        ...mapGetters('sheet', ['getSchoolSuppliesQuestions'])
    },
    watch: {
        needSchoolSupplies (val) {
            if (val === 'no') {
                this.$nextTick(() => {
                    this.selectedSupplies = [];
                });
            }
        },
        showAnotherField (val) {
            if (val === false) {
                this.anotherSchoolSupplies = null;
            }
        }
    }
};
</script>

<style scoped></style>
